<form class="lp-login-form" [formRoot]="loginForm">
  <h1 i18n="@@auth.login.titel" class="dm-margin-bottom-12 dm-text-display-xs desktop:dm-text-display-sm dm-text-weight-semibold">
    Willkommen zurück
  </h1>

  @if (isForAdmin()) {
    <p i18n="@@auth.login.anleitungDu" class="dm-text-md dm-margin-bottom-32">
      Bitte melde dich mit deiner E-Mail-Adresse und deinem Passwort an.
    </p>
  } @else {
    <p i18n="@@auth.login.anleitungSie" class="dm-text-md dm-margin-bottom-32">
      Bitte melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an.
    </p>
  }

  <lp-form-alert [message]="loginErrorMessage()" />

  <dm-input
    i18n-label="@@auth.login.email"
    label="E-Mail"
    inputtype="email"
    inputId="email"
    autocomplete="username"
    i18n-placeholder="@@auth.emailPlatzhalter"
    placeholder="E-Mail-Adresse eingeben"
    [formField]="loginForm.email"
    [errormsg]="emailErrorMessage()"
  />

  <div class="dm-margin-top-20">
    <dm-input
      i18n-label="@@auth.login.passwort"
      label="Passwort"
      class="margin-top-20"
      inputtype="password"
      inputId="password"
      autocomplete="current-password"
      i18n-placeholder="@@auth.login.passwortPlatzhalter"
      placeholder="Passwort eingeben"
      i18n-showPasswordLabel="@@common.input.passwortAnzeigen"
      showPasswordLabel="Passwort anzeigen"
      i18n-hidePasswordLabel="@@common.input.passwortVerbergen"
      hidePasswordLabel="Passwort verbergen"
      [formField]="loginForm.password"
      [errormsg]="passwordErrorMessage()"
    />
  </div>

  <div class="dm-margin-top-24 dm-text-align-center dm-text-sm">
    <a i18n="@@auth.login.passwortVergessen" [routerLink]="changePasswordRoute">Passwort vergessen</a>
  </div>

  <div class="dm-margin-top-24 dm-margin-bottom-32">
    <dm-button
      i18n="@@auth.login.anmelden"
      dmType="submit"
      [grow]="true"
      [isLoading]="loadingStatus() === 'loading'"
      [disabled]="loginForm().invalid()"
    >
      Anmelden
    </dm-button>
  </div>

  @if (isForAdmin()) {
    <p i18n="@@auth.login.keinKontoDu" class="dm-text-sm dm-text-align-center">
      Noch kein Konto?
      <a [href]="contactUrl" target="_blank" rel="noopener">Kontaktiere uns.</a>
    </p>
  } @else {
    <p i18n="@@auth.login.keinKontoSie" class="dm-text-sm dm-text-align-center">
      Noch kein Konto?
      <a [href]="contactUrl" target="_blank" rel="noopener">Kontaktieren Sie uns.</a>
    </p>
  }
</form>
